// see:  https://w3c.github.io/webauthn/#sec-assertion-privacy
// see:  https://webauthn.guide/
// see:  https://developer.mozilla.org/en-US/docs/Web/API/Web_Authentication_API

const baseFido2Url = 'static/lib/server.php'

/**
 * creates a new FIDO2 registration
 * @returns {undefined}
 */
export function registerNewUser (userDetails) {
    if (!window.fetch || !navigator.credentials || !navigator.credentials.create) {
        // window.alert('Browser not supported.')
        // return
        throw (new Error(`Browser does not support 'WebAuthn' API!`))
    }

    // Ensure user has (new) random user-id
    if (!userDetails.userId) {
        let randomBytes = new Uint8Array(16)
        window.crypto.getRandomValues(randomBytes)
        // Get userid as a string of 32 hex digits (16 bytes).
        randomBytes.forEach(byte => {
            let hexDigits = byte.toString(16)
            if (hexDigits.length === 2) {
                userDetails.userId += hexDigits
            } else {
                userDetails.userId += '0' + hexDigits
            }
        })
    }

    console.log(`helper-fido2.registerNewUser: userDetails`, userDetails)

    // get default args
    let currentChallenge = ''

    const fido2Url = `${baseFido2Url}?fn=requestCreateArgs${getGetParams()}`

    return window.fetch(fido2Url, {method: 'POST', cache: 'no-cache', body: JSON.stringify(userDetails)})
        .then(function (response) {
            return response.json()
        })
        // convert base64 to arraybuffer
        .then(function (json) {
            // error handling
            if (json.success === false) {
                throw new Error(json.msg)
            }

            // replace binary base64 data with ArrayBuffer. a other way to do this
            // is the reviver function of JSON.parse()

            currentChallenge = json.currentChallenge

            recursiveBase64StrToArrayBuffer(json)
            return json

            // create credentials
        }).then(function (createCredentialArgs) {
            console.log(createCredentialArgs)
            return navigator.credentials.create(createCredentialArgs.createArgs)

            // convert to base64
        }).then(function (cred) {
            return {
                clientDataJSON: cred.response.clientDataJSON ? arrayBufferToBase64(cred.response.clientDataJSON) : null,
                attestationObject: cred.response.attestationObject ? arrayBufferToBase64(cred.response.attestationObject) : null,
                userId: window.btoa(userDetails.userId), // $$$ Not a fido2/webauthn standard property !!
                currentChallenge: currentChallenge // $$$ Not a fido2/webauthn standard property !!
            }

            // *** transfer to server ***
        })
        .then(JSON.stringify)
        .then(function (AuthenticatorAttestationResponse) {
            // $$$ debugger
            // console.log('*** AuthenticatorAttestationResponse', AuthenticatorAttestationResponse)

            let fido2Url = `${baseFido2Url}?fn=requestProcessCreate${getGetParams()}`
            return window.fetch(fido2Url, {method: 'POST', body: AuthenticatorAttestationResponse, cache: 'no-cache'})

            // convert to JSON
        }).then(function (response) {
            return response.json()

            // analyze response
        }).then(function (json) {
            // $$$ if (json.success) {
            if (json.errors.length === 0) {
                window.alert('registration success')
            } else {
                throw new Error(json.msg)
            }

            // catch errors
        }).catch(function (err) {
            window.alert(err.message || 'unknown error occured')
        })
}

/**
 * checks a FIDO2 registration
 * @returns {undefined}
 */
export function checkUserLogin (userDetails) {
    if (!window.fetch || !navigator.credentials || !navigator.credentials.create) {
        window.alert('Browser not supported.')
        return
    }

    // get default args
    let currentChallenge = ''

    let fido2Url = `${baseFido2Url}?fn=requestGetArgs${getGetParams()}`
    return window.fetch(fido2Url, {method: 'POST', cache: 'no-cache', body: JSON.stringify(userDetails)}).then(function (response) {
        return response.json()
        // convert base64 to arraybuffer
    }).then(function (json) {
        // error handling
        // $$$ if (json.success === false) {
        if (json.errors.length > 0) {
            throw new Error(json.msg)
        }

        currentChallenge = json.currentChallenge
        // console.log(`helper-fido2.checkUserLogin: currentChallenge:`, currentChallenge)

        // replace binary base64 data with ArrayBuffer. a other way to do this
        // is the reviver function of JSON.parse()
        recursiveBase64StrToArrayBuffer(json)
        return json

        // create credentials
    }).then(function (getCredentialArgs) {
        console.log(`helper-fido2.checkUserLogin: getCredentialArgs:`, getCredentialArgs)
        if (!userDetails.UserId && getCredentialArgs.results.length > 0) {
            try {
                // $$$ FIX UGLY HACK:
                let temp = getCredentialArgs.results[getCredentialArgs.results.length - 1].rows[0]
                userDetails.UserId = temp.UserId
                userDetails.DisplayName = temp.DisplayName
                // $$$ TODO: Cryptographical Access-Token needed here !!
            } catch (err) {
                // debugger
                // $$$ TODO: handle error !!
                throw err
            }
        }
        return navigator.credentials.get(getCredentialArgs)

        // convert to base64
    }).then(function (cred) {
        console.log(`helper-fido2.checkUserLogin: cred:`, cred)
        return {
            id: cred.rawId ? arrayBufferToBase64(cred.rawId) : null,
            clientDataJSON: cred.response.clientDataJSON ? arrayBufferToBase64(cred.response.clientDataJSON) : null,
            authenticatorData: cred.response.authenticatorData ? arrayBufferToBase64(cred.response.authenticatorData) : null,
            signature: cred.response.signature ? arrayBufferToBase64(cred.response.signature) : null,
            currentChallenge: currentChallenge
        }

        // *** transfer to server ***
    }).then(JSON.stringify).then(function (AuthenticatorAttestationResponse) {
        let fido2Url = `${baseFido2Url}?fn=requestProcessGet${getGetParams()}`
        return window.fetch(fido2Url, {method: 'POST', body: AuthenticatorAttestationResponse, cache: 'no-cache'})

        // convert to json
    }).then(function (response) {
        return response.json()

        // analyze response
    }).then(function (json) {
        if (json.errors.length === 0 && json.msg === 'SUCCESS') {
            window.alert(json.msg)
            // $$$ TODO: Propagate login to application...
            userDetails.token = json.token
            userDetails.tokenExpires = json.tokenExpires
            console.log(`SUCCESS: userDetails:`, userDetails)
            return userDetails
        } else {
            // throw new Error(json.msg)
            // throw new Error(json.errors[0])
            return undefined
        }

        // catch errors
    }).catch(function (err) {
        console.error(err || 'unknown error occured')
        window.alert(err.message || 'unknown error occured')
        return undefined // {errors: [err.message || 'unknown error occured']}
    })
}

/**
 * convert RFC 1342-like base64 strings to array buffer
 * @param {mixed} obj
 * @returns {undefined}
 */
function recursiveBase64StrToArrayBuffer (obj) {
    let prefix = '?BINARY?B?'
    let suffix = '?='
    if (typeof obj === 'object') {
        for (let key in obj) {
            if (typeof obj[key] === 'string') {
                let str = obj[key]
                if (str.substring(0, prefix.length) === prefix && str.substring(str.length - suffix.length) === suffix) {
                    str = str.substring(prefix.length, str.length - suffix.length)

                    let binaryString = window.atob(str)
                    let len = binaryString.length
                    let bytes = new Uint8Array(len)
                    for (var i = 0; i < len; i++) {
                        bytes[i] = binaryString.charCodeAt(i)
                    }
                    obj[key] = bytes.buffer
                }
            } else {
                recursiveBase64StrToArrayBuffer(obj[key])
            }
        }
    }
}

/**
 * Convert a ArrayBuffer to Base64
 * @param {ArrayBuffer} buffer
 * @returns {String}
 */
function arrayBufferToBase64 (buffer) {
    var binary = ''
    var bytes = new Uint8Array(buffer)
    var len = bytes.byteLength
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary)
}

/**
 * Get URL parameter
 * @returns {String}
 */
function getGetParams () {
    let url = ''
    url += '&yubico=0' //  + (document.getElementById('cert_yubico').checked ? '1' : '0')
    url += '&solo=0' // + (document.getElementById('cert_solo').checked ? '1' : '0')
    url += '&hypersecu=0' // + (document.getElementById('cert_hypersecu').checked ? '1' : '0')
    url += '&google=0' // + (document.getElementById('cert_google').checked ? '1' : '0')

    url += '&requireResidentKey=1' //  + (document.getElementById('requireResidentKey').checked ? '1' : '0')

    url += '&fmt_android-key=1' // + (document.getElementById('fmt_android-key').checked ? '1' : '0')
    url += '&fmt_android-safetynet=1' // + (document.getElementById('fmt_android-safetynet').checked ? '1' : '0')
    url += '&fmt_fido-u2f=1' // + (document.getElementById('fmt_fido-u2f').checked ? '1' : '0')
    url += '&fmt_none=1' // + (document.getElementById('fmt_none').checked ? '1' : '0')
    url += '&fmt_packed=1' // + (document.getElementById('fmt_packed').checked ? '1' : '0')
    url += '&fmt_tpm=0' // + (document.getElementById('fmt_tpm').checked ? '1' : '0')

    let rpId = location.hostname
    url += '&rpId=' + encodeURIComponent(rpId) //  + encodeURIComponent(document.getElementById('rpId').value)

    return url
}



// WEBPACK FOOTER //
// ./src/components/services/helper-fido2.js